import { getWithAuth } from "./InitializeService";

/**
 * Get current authenticated user information
 * Uses the authenticated user's context from the JWT token to fetch user details from the API
 * @returns
 */

export const getCurrentUser = () => {
  return getWithAuth("me");
};

/**
 * Get user information by login name
 * @param loginName
 * @returns
 */

export const getUserByLoginName = (loginName: string) => {
  return getWithAuth(`users?loginname=${encodeURIComponent(loginName)}`);
};

/**
 *  Search staff by name (full name or login name)
 *  Supports partial matches and returns top 10 results ordered by full name
 * @param name
 * @returns
 */

export const searchStaffByName = (name: string) => {
  return getWithAuth(
    `users?$filter=(contains(FullName,'${name}') or contains(LoginName,'${name}')) and active eq true&$orderby=fullName&$top=10&$skip=0`,
  );
};

/**
 * Search staff by PBS People Picker query
 * @param query - The search query string from the People Picker input
 * @returns Promise resolving to an array of user objects matching the search criteria
 */

export const searchStaffByPBSPeoplePicker = (query: any) => {
  return getWithAuth(
    `users?$search=${query}&$select=Id,FullName,Email,LoginName,Role,Region,SPID&$top=10`,
  );
};

/**
 * Get user information by email
 * Uses the authenticated user's context from the JWT token to fetch user details from the API
 * @param email
 * @returns
 */

export const getUserByEmail = (email: string) => {
  return getWithAuth(`users?email=${email}`);
};
